import {Component, Input} from "@angular/core";
import {AriadVerificationStatus} from "../../api/entity";

@Component({
    selector: 'tfl-bo-ariadnext-status-badge',
    template: `
        <div [ngSwitch]="status" class="badge-box">
            <span *ngSwitchCase="'OK'" class="label label-success">
                <small *ngIf="explanation">{{ explanation }}</small>
                {{ 'CUSTOMER.VERIFICATION.BLOCK.STATUS.OK' | translate }}
            </span>
            <span *ngSwitchCase="'ERROR'" class="label label-danger">
                <small *ngIf="explanation">{{ explanation }}</small>
                {{ 'CUSTOMER.VERIFICATION.BLOCK.STATUS.ERROR' | translate }}
            </span>
            <span *ngSwitchCase="'NONE'" class="label label-default">
                <small *ngIf="explanation">{{ explanation }}</small>
                {{ 'CUSTOMER.VERIFICATION.BLOCK.STATUS.NONE' | translate }}
            </span>
            <span *ngSwitchCase="'WARN'" class="label label-warning">
                <small *ngIf="explanation">{{ explanation }}</small>
                {{ 'CUSTOMER.VERIFICATION.BLOCK.STATUS.WARN' | translate }}
            </span>
            <span *ngSwitchCase="'OBSOLETE'" class="label label-info">
                <small *ngIf="explanation">{{ explanation }}</small>
                {{ 'CUSTOMER.VERIFICATION.BLOCK.STATUS.OBSOLETE' | translate }}
            </span>
            <span *ngSwitchCase="'OUT_OF_VERIFICATION'" class="label label-default">
                <small *ngIf="explanation">{{ explanation }}</small>
                {{ 'CUSTOMER.VERIFICATION.BLOCK.STATUS.OUT_OF_VERIFICATION' | translate }}
            </span>
        </div>
    `
})
export class AriadStatusBadgeComponent {

    @Input() status: AriadVerificationStatus;
    @Input() explanation: string = null;

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/components/ariadnext/ariad.status-badge.component.ts